import React, { useEffect, useRef, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getSession, getDashboardStats, logout } from '../../services/api';
import usePolling from '../../hooks/usePolling';
import SiteFooter from '../SiteFooter';

const DashboardLayout = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [stats, setStats] = useState(null);
  const previousTotal = useRef(null);

  useEffect(() => {
    getSession()
      .then(setUser)
      .catch(() => navigate('/recruteur/login', { replace: true }));
  }, [navigate]);

  // Statistiques partagées avec les pages ; signale les nouvelles candidatures
  const lastUpdate = usePolling(async () => {
    if (!user) return;
    const data = await getDashboardStats();
    if (previousTotal.current !== null && data.total > previousTotal.current) {
      const n = data.total - previousTotal.current;
      toast.info(`${n} nouvelle${n > 1 ? 's' : ''} candidature${n > 1 ? 's' : ''}`, {
        onClick: () => navigate('/recruteur/list'),
      });
    }
    previousTotal.current = data.total;
    setStats(data);
  }, undefined, [user]);

  const handleLogout = async () => {
    try { await logout(); } catch { /* session déjà close */ }
    navigate('/recruteur/login');
  };

  if (!user) {
    return <div className="loader"><div className="spinner" /></div>;
  }

  const aExaminer = stats?.suivi?.a_examiner || 0;

  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>ECV 2026</h2>
          <p>Recrutement · INSAPT</p>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/recruteur" end>Tableau de bord</NavLink>
          <NavLink to="/recruteur/list">
            Candidatures
            {aExaminer > 0 && <span className="nav-badge" title="À examiner">{aExaminer}</span>}
          </NavLink>
          <NavLink to="/recruteur/parametres">Paramètres</NavLink>
          <a href="/" target="_blank" rel="noopener noreferrer">Formulaire public ↗</a>
        </nav>
        <div className="sidebar-footer">
          <span className="user">{user.username}</span>
          <button className="btn btn-ghost btn-sm" onClick={handleLogout}>Déconnexion</button>
        </div>
      </aside>
      <main className="main-content">
        <div className="main-inner">
          <Outlet context={{ stats, lastUpdate }} />
        </div>
        <SiteFooter />
      </main>
    </div>
  );
};

export default DashboardLayout;
